export const iconFontAwesomeHouseholdBell = (
	<i className="fa-solid fa-bell"></i>
);
